import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import Drawer from 'antd/es/drawer';
import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import AssistantSiderHeader from './AssistantSiderHeader';
import { AssistantArrowOutlineStyled, AssistantSiderContainer, AssistantSiderStyled, AssistantTriggerStyled, } from './styles';
const AssistantSiderWrapper = ({ children, setIsOpen, isOpen, onCreateConversation, }) => {
    const theme = useTheme();
    const isSmallDesktop = useMediaQuery({ maxWidth: theme.breakpoints.md });
    useEffect(() => {
        if (isSmallDesktop) {
            setIsOpen(false);
        }
    }, [isSmallDesktop, setIsOpen]);
    if (!isSmallDesktop) {
        const collapsed = !isOpen;
        return (_jsx(AssistantSiderStyled, { width: 350, style: { height: '100%' }, collapsible: true, collapsed: collapsed, onCollapse: () => setIsOpen(!isOpen), trigger: _jsx(AssistantTriggerStyled, { style: {
                    top: theme.appearance.appHeaderHeight +
                        theme.spacing.xxl +
                        theme.spacing.xl,
                }, children: _jsx(AssistantArrowOutlineStyled, { size: 24, style: {
                        transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 500ms linear',
                    } }) }), children: _jsxs(AssistantSiderContainer, { "$collapsed": collapsed, children: [!collapsed && (_jsx(AssistantSiderHeader, { onCreateConversation: onCreateConversation })), children] }) }));
    }
    const handleDrawer = () => setIsOpen(!isOpen);
    return (_jsxs(_Fragment, { children: [_jsx(AssistantSiderHeader, { handleClose: handleDrawer, open: false }), _jsx(Drawer, { styles: {
                    header: {
                        padding: 0,
                        flexDirection: 'row-reverse',
                    },
                    content: {
                        background: theme.colors.white_1,
                        padding: 0,
                    },
                }, title: _jsx(AssistantSiderHeader, { handleClose: handleDrawer, open: isOpen, onCreateConversation: onCreateConversation }), closable: false, placement: "right", onClose: () => setIsOpen(false), open: isOpen, width: '100%', children: children })] }));
};
export default AssistantSiderWrapper;
